import styled from 'styled-components'

import TableLink, { TableLinkProps } from './TableLink'

const Column = styled.div`
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Title = styled.span<{ strong?: boolean }>`
  ${({ theme }) => theme.font.body03}
  color: ${({ theme }) => theme.colour.secondary.base};
  font-weight: ${({ strong }) => (strong ? 'bold' : 'normal')};
`

const Subtitle = styled.span`
  ${({ theme }) => theme.font.caption01}
  color: ${({ theme }) => theme.colour.secondary._400};
`

type Props = {
  title: React.ReactNode
  subtitle?: React.ReactNode
  titleLink?: () => void
  strong?: boolean
  extra?: React.ReactNode
  href?: string
  subtitleFirst?: boolean
  linkProps?: TableLinkProps
}

const TitleColumn: React.FC<Props> = ({
  title,
  subtitle,
  titleLink,
  strong,
  extra,
  href,
  subtitleFirst,
  linkProps,
}) => {
  const content = (
    <Column>
      {subtitleFirst && <Subtitle>{subtitle}</Subtitle>}
      <Title strong={strong}>{title}</Title>
      {!subtitleFirst && <Subtitle>{subtitle}</Subtitle>}
    </Column>
  )

  return (
    <Row>
      {titleLink || href ? (
        <TableLink onClick={titleLink} href={href} {...linkProps}>
          {content}
        </TableLink>
      ) : (
        content
      )}
      {extra}
    </Row>
  )
}

export default TitleColumn
